/* ef-cfg-save.js — Save-your-design v1 + Expert-measure CTA (2026-08-10, GO Daniela)
   Moduł ADDYTYWNY do ef-configurator-bar-iron.js: czyta window._efCfgState, niczego w silniku
   nie nadpisuje. Trzy zadania:
   1) SAVE: serializacja konfiguracji do linku (?efd=), localStorage-autosave,
      baner "Welcome back", modal Copy/Share/Email (Klaviyo event "EF Saved Design").
   2) RESTORE: z ?efd= albo z banera — wymiary przez input events, opcje przez
      programowy click w karty [data-field][data-value] (pełny pipeline silnika:
      dopłaty, cena, podmiany galerii). Pętla ponawiań łapie karty renderowane
      później (np. mesh po wyborze door_type).
   3) EXPERT CTA: tracking kliknięć + delikatny "nudge" karty po 25 s na kroku
      wymiarów albo po 2 nieudanych parse'ach wymiaru.
   dataLayer: ef_cfg_save {method} · ef_cfg_restore {source, applied, pending}
   · ef_cfg_expert_cta {action}. */
(function () {
  'use strict';
  var LS_PREFIX = 'ef-saved-design:';
  var MAX_AGE_DAYS = 30;

  function dl(ev, props) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: ev };
      for (var k in props) p[k] = props[k];
      window.dataLayer.push(p);
      /* gtag.js (ef-analytics) ignoruje pushe w stylu GTM — forward jawnie,
         ten sam wzorzec co efTrack w silniku (ef-configurator-bar-iron.js). */
      if (typeof window.gtag === 'function') {
        var g = {};
        for (var gk in p) if (Object.prototype.hasOwnProperty.call(p, gk) && gk !== 'event') g[gk] = p[gk];
        window.gtag('event', ev, g);
      }
    } catch (e) {}
  }

  function state() { return window._efCfgState || null; }

  function handle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : location.pathname;
  }

  /* ── serializacja ─────────────────────────────────────────────── */
  function b64e(obj) {
    var json = JSON.stringify(obj);
    return btoa(unescape(encodeURIComponent(json)))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64d(str) {
    try {
      var s = str.replace(/-/g, '+').replace(/_/g, '/');
      while (s.length % 4) s += '=';
      return JSON.parse(decodeURIComponent(escape(atob(s))));
    } catch (e) { return null; }
  }

  function snapshot() {
    var st = state();
    if (!st) return null;
    var sel = {};
    var any = false;
    for (var k in st.selections) { sel[k] = st.selections[k]; any = true; }
    var notes = document.getElementById('efCfgNotes');
    if (notes && notes.value) { sel.__notes = notes.value; any = true; }
    /* DIRECT-1o: remember the chapter the buyer stood in, so Resume lands there. */
    var visS = document.querySelector('.ef-cfg-step.is-visible');
    if (visS) { var allS = [].slice.call(document.querySelectorAll('.ef-cfg-step')); var si = allS.indexOf(visS); if (si > 0) sel.__step = si; }
    if (!any) return null;
    return { h: handle(), s: sel, t: Date.now() };
  }

  /* DIRECT-2d — the review step's QR reads the same link the Save modal shows */
  window.efCfgBuildLink = function () { try { return buildLink(); } catch (e) { return null; } };
  function buildLink() {
    var snap = snapshot();
    if (!snap) return null;
    return location.origin + location.pathname + '?efd=' + b64e({ h: snap.h, s: snap.s });
  }

  /* Czy konfiguracja jest warta zapisu (realne zaangażowanie, nie same defaulty) */
  function isMeaningful(sel) {
    if (!sel) return false;
    if (sel._width || sel._height) return true;
    var n = 0;
    for (var k in sel) { if (k.charAt(0) !== '_' && k !== '__notes') n++; }
    return n >= 2;
  }

  /* ── restore ──────────────────────────────────────────────────── */
  var DIM_INPUTS = { _width: 'efCfgWidth', _height: 'efCfgHeight', _side_height: 'efCfgSideHeight' };
  /* EF Design Lab: never autosave an intermediate/failed replay over its source. */
  var restoreBusy = false, heldRestore = null, restoreSerial = 0;
  var stopLateRestore = null;
  var pendingResume = null, studioHandoff = null;

  /* Studio links are one-time, partial prefills. Full Save URLs retain their
     existing replay semantics. Never accept dimensions, notes or a step here. */
  function isStudioSelection(sel) {
    if (!sel || typeof sel !== 'object' || Array.isArray(sel)) return false;
    var keys = Object.keys(sel);
    return keys.length >= 1 && keys.length <= 2 && keys.every(function (key) {
      return (key === 'finish' || key === 'glass') && typeof sel[key] === 'string' &&
        sel[key].trim().length > 0 && sel[key].length <= 160;
    });
  }
  function isStudioDesign(data) {
    return !!(data && typeof data === 'object' && !Array.isArray(data) &&
      Object.keys(data).length === 2 && data.h === handle() && isStudioSelection(data.s));
  }
  function persistSnapshot(snap) {
    if (!snap) return false;
    try {
      var value = JSON.stringify(snap), key = LS_PREFIX + snap.h;
      localStorage.setItem(key, value);
      if (localStorage.getItem(key) !== value) return false;
      lastSaved = JSON.stringify(snap.s);
      return true;
    } catch (e) { return false; }
  }
  function finishStudioHandoff() {
    if (!studioHandoff || !studioHandoff.restored || pendingResume || restoreBusy || heldRestore) return;
    try {
      var url = new URL(location.href);
      if (url.searchParams.get('ef_studio') !== '1' || url.searchParams.get('efd') !== studioHandoff.token) return;
      var snap = snapshot();
      if (!snap) return;
      // A single explicitly chosen option is useful for this partial prefill.
      // Keep the ordinary Save/autosave meaningful-design threshold unchanged.
      if (!isMeaningful(snap.s)) {
        if (!isStudioSelection(snap.s)) return;
        snap.studio = true;
      }
      if (!persistSnapshot(snap)) throw new Error('Studio save unavailable');
      url.searchParams.delete('ef_studio');
      url.searchParams.delete('efd');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      studioHandoff = null;
    } catch (e) {
      if (studioHandoff && !studioHandoff.warned) {
        studioHandoff.warned = true;
        toast('Keep this page open and use Save to copy your design link before refreshing or leaving.');
      }
    }
  }

  function setInput(id, val) {
    var el = document.getElementById(id);
    if (!el) return false;
    el.value = val;
    ['input', 'change', 'blur'].forEach(function (t) {
      try { el.dispatchEvent(new Event(t, { bubbles: true })); } catch (e) {}
    });
    return true;
  }

  /* DIRECT-1o (owner 3 IX: "resume nie przechodzi do punktu, pojawia się kolor") — the programmatic
     swatch click opens the wizard's finish popup (#efCfgSwatchPopup.is-visible) inside a hidden chapter,
     which then paints at the top of the page; and nothing navigated. Both fixed here, outside the engine. */
  function hidePopup() { var pp = document.getElementById('efCfgSwatchPopup'); if (pp) pp.classList.remove('is-visible'); try { if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); } catch (e) {} }
  function stepIndex() { var v = document.querySelector('.ef-cfg-step.is-visible'); return v ? [].slice.call(document.querySelectorAll('.ef-cfg-step')).indexOf(v) : -1; }
  function goToSavedStep(target, done, isCurrent) {
    function finish(ok) { hidePopup(); if (done) done(ok); }
    target = parseInt(target, 10); if (!isFinite(target) || target <= 0) { finish(true); return; }
    var hops = 0;
    (function hop() {
      if (isCurrent && !isCurrent()) return;
      var cur = stepIndex();
      if (cur < 0 || cur >= target || hops++ > 12) { finish(cur >= target); return; }
      var nx = document.getElementById('efCfgNext'); if (!nx) { finish(false); return; }
      nx.click();
      var waited = 0;
      (function poll() { if (isCurrent && !isCurrent()) return; waited += 200; if (stepIndex() !== cur) { hidePopup(); setTimeout(hop, 700); } else if (waited < 4000) { setTimeout(poll, 200); } else { finish(false); } })();
    })();
  }
  function applyDesign(sel, source, onComplete) {
    if (!sel || typeof sel !== 'object') return;
    if (stopLateRestore) stopLateRestore();
    var serial = ++restoreSerial;
    restoreBusy = true;
    heldRestore = null;
    var cfg = document.getElementById('efCfg');
    /* Exact Slim product state: replay through the native Stoll tier/finish model.
       The common UI, share URLs, autosave and resume banner remain authoritative. */
    var slim = state();
    if (slim && slim.isBarIron && typeof slim.barRestore === 'function') {
      var notes = document.getElementById('efCfgNotes');
      if (notes) notes.value = typeof sel.__notes === 'string' ? sel.__notes : '';
      slim.barRestore({ selections: sel, curStep: sel.__step || 1 });
      restoreBusy = false;
      heldRestore = null;
      hidePopup();
      var fields = ['_width', '_height', 'finish', 'mesh', 'bar_feet', 'bar_design'];
      var missed = fields.filter(function (field) { return sel[field] && slim.selections[field] !== sel[field]; });
      dl('ef_cfg_restore', { source: source, applied: fields.filter(function (field) { return !!sel[field]; }).length - missed.length, pending: missed.length });
      toast(missed.length ? 'Some choices could not be restored. Please review your screen options.' : (sel.door_finish && sel.door_finish !== sel.finish ? 'Your saved frame finish now applies to the entire screen. Please review before ordering.' : 'Your screen choices are restored. Please review before ordering.'));
      if (onComplete) onComplete();
      return;
    }
    var pending = [];
    for (var k in sel) {
      if (k === '__notes') {
        var notes = document.getElementById('efCfgNotes');
        if (notes) notes.value = sel[k];
        continue;
      }
      if (DIM_INPUTS[k]) { setInput(DIM_INPUTS[k], sel[k]); continue; }
      if (k.charAt(0) === '_') continue;
      if (sel[k] !== null && sel[k] !== '') pending.push(k);
    }
    var restoreFields = pending.slice();
    var applied = 0;
    var searchedTabs = [];
    function matches(field) {
      var st = state();
      return !!(st && st.selections && st.selections[field] === sel[field]);
    }
    function frameSwatch(label) {
      var grid = document.getElementById('efCfgSwatchGrid');
      var tabs = document.getElementById('efCfgFinishTabs');
      if (!grid) return null;
      function find() {
        var sw = grid.querySelectorAll('.ef-cfg-swatch');
        for (var n = 0; n < sw.length; n++) if (sw[n].dataset.label === label) return sw[n];
        return null;
      }
      var found = find();
      if (found || !tabs) return found;
      var buttons = tabs.querySelectorAll('.ef-cfg-tab');
      var active = tabs.querySelector('.ef-cfg-tab.is-active');
      /* The engine normalizes categories privately. Ask its real tab handlers to
         render them; do not guess a category or copy price/variant data. Each tab
         is searched once per restore, avoiding a mutation-observer feedback loop. */
      for (var n = 0; n < buttons.length; n++) {
        if (searchedTabs.indexOf(buttons[n]) !== -1) continue;
        searchedTabs.push(buttons[n]);
        if (!buttons[n].classList.contains('is-active')) buttons[n].click();
        found = find();
        if (found) return found;
      }
      if (active && !active.classList.contains('is-active')) active.click();
      return null;
    }
    function attempt() {
      if (serial !== restoreSerial) return false;
      for (var i = pending.length - 1; i >= 0; i--) {
        var field = pending[i];
        /* Card/swatch clicks toggle off when already selected. This also recognizes
           derived values such as size after the dimension-input events compute it. */
        if (matches(field)) { pending.splice(i, 1); continue; }
        var hit = null;
        var cards = cfg ? cfg.querySelectorAll('.ef-cfg-card[data-field]') : [];
        for (var j = 0; j < cards.length; j++) {
          if (cards[j].dataset.field === field && cards[j].dataset.value === sel[field]) { hit = cards[j]; break; }
        }
        if (!hit && field === 'finish') hit = frameSwatch(sel[field]);
        /* Keep secondary finish lookups in their own existing grid: identical raw
           labels in a style/handle palette must never click the frame finish. */
        if (!hit && (field === 'style_finish' || field === 'hardware_finish')) {
          var otherGrid = document.getElementById(field === 'style_finish' ? 'efCfgStyleFinishGrid' : 'efCfgHardwareGrid');
          var sw = otherGrid ? otherGrid.querySelectorAll('.ef-cfg-swatch') : [];
          for (var q = 0; q < sw.length; q++) {
            if (sw[q].dataset.label === sel[field]) { hit = sw[q]; break; }
          }
        }
        if (hit) {
          try { if (hit.getAttribute('aria-checked') !== 'true') hit.click(); } catch (e) {}
          hidePopup();
          if (matches(field)) pending.splice(i, 1);
        }
      }
      /* A later dependency (e.g. fireplace type) can clear a choice restored earlier
         in this pass. Only the engine's final state counts as restored. */
      restoreFields.forEach(function (field) { if (!matches(field) && pending.indexOf(field) === -1) pending.push(field); });
      applied = restoreFields.length - pending.length;
      return pending.length === 0;
    }
    /* Runda 1: karty już wyrenderowane (krok 1 + wszystko, co silnik zbudował z góry). */
    var tries = 0, navStarted = false, navDone = false, navOK = false, reported = false;
    function complete() {
      if (serial !== restoreSerial || pending.length || !navDone) return;
      /* Navigation can rebuild a step after the first replay. Recheck the engine
         before reporting success; one final pass uses the existing failure path. */
      if (!attempt()) { tries = 20; pass(); return; }
      restoreBusy = false;
      heldRestore = null;
      if (stopLateRestore) stopLateRestore();
      if (!reported) {
        reported = true;
        dl('ef_cfg_restore', { source: source, applied: applied, pending: 0 });
        toast(navOK ? 'Your design is back ✓' : 'Your choices are restored. Please review the highlighted step.');
      }
      // Persistence warnings from a one-time handoff must remain the final
      // visible message rather than being replaced by the restore toast.
      if (onComplete) { var callback = onComplete; onComplete = null; callback(); }
    }
    function navigate() {
      goToSavedStep(sel.__step, function (ok) {
        if (serial !== restoreSerial) return;
        navDone = true; navOK = ok; complete();
      }, function () { return serial === restoreSerial; });
    }
    function pass() {
      if (serial !== restoreSerial) return;
      tries++;
      var done1 = attempt();
      if (tries === 1 && !navStarted) { navStarted = true; hidePopup(); setTimeout(navigate, 250); }
      if (!done1 && tries < 20) { setTimeout(pass, 400); return; }
      if (done1) { complete(); return; }
      restoreBusy = false;
      heldRestore = {};
      restoreFields.forEach(function (field) { heldRestore[field] = sel[field]; });
      dl('ef_cfg_restore', { source: source, applied: applied, pending: pending.length });
      toast('Some choices could not be restored. Your saved design is unchanged.');
      hidePopup();
      /* Runda 2: silnik renderuje karty niektórych kroków dopiero przy nawigacji
         (np. finish/mesh). Obserwator DOM dociska zaległe wybory w chwili, gdy
         karty się pojawią — klient klika Next i zastaje wszystko wybrane. */
      if (pending.length && 'MutationObserver' in window) {
        var debounce = null;
        var mo = new MutationObserver(function () {
          if (serial !== restoreSerial) { mo.disconnect(); return; }
          clearTimeout(debounce);
          debounce = setTimeout(function () {
            if (attempt()) { mo.disconnect(); dl('ef_cfg_restore_late', { applied: applied }); complete(); }
            hidePopup();
          }, 250);
        });
        mo.observe(document.body, { childList: true, subtree: true });
        var deadline = setTimeout(function () { mo.disconnect(); clearTimeout(debounce); stopLateRestore = null; }, 90000);
        stopLateRestore = function () { mo.disconnect(); clearTimeout(debounce); clearTimeout(deadline); stopLateRestore = null; };
      }
    }
    pass();
  }

  /* ── localStorage autosave ────────────────────────────────────── */
  var lastSaved = '';
  function autosave() {
    if (restoreBusy || pendingResume) return;
    if (heldRestore) {
      var st = state();
      for (var field in heldRestore) {
        if (!st || !st.selections || st.selections[field] !== heldRestore[field]) return;
      }
      heldRestore = null;
    }
    if (studioHandoff) { finishStudioHandoff(); return; }
    var snap = snapshot();
    if (!snap || !isMeaningful(snap.s)) return;
    var json = JSON.stringify(snap.s);
    if (json === lastSaved) return;
    persistSnapshot(snap);
  }

  function loadSaved() {
    try {
      var raw = localStorage.getItem(LS_PREFIX + handle());
      if (!raw) return null;
      var snap = JSON.parse(raw);
      if (!snap || (!isMeaningful(snap.s) && !(snap.studio === true && snap.h === handle() && isStudioSelection(snap.s)))) return null;
      if (Date.now() - (snap.t || 0) > MAX_AGE_DAYS * 864e5) return null;
      return snap;
    } catch (e) { return null; }
  }

  /* ── UI: toast ────────────────────────────────────────────────── */
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ef-sv-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ── UI: baner "Welcome back" ─────────────────────────────────── */
  function showResumeBanner(snap, fromStudio) {
    pendingResume = snap;
    var firstStep = document.querySelector('.ef-cfg-step');
    if (!firstStep || document.getElementById('efSvBanner')) return;
    var days = Math.floor((Date.now() - snap.t) / 864e5);
    var when = days === 0 ? 'earlier today' : (days === 1 ? 'yesterday' : days + ' days ago');
    var el = document.createElement('div');
    el.className = 'ef-sv-banner';
    el.id = 'efSvBanner';
    el.innerHTML =
      '<div class="ef-sv-banner__txt">' + (fromStudio
        ? '<strong>You have a saved design.</strong> Choose which design to continue before new progress is saved.'
        : '<strong>Welcome back.</strong> Your design from ' + when + ' is saved.') + '</div>' +
      '<div class="ef-sv-banner__btns">' +
      '<button type="button" class="ef-sv-banner__resume" id="efSvResume">' + (fromStudio ? 'Resume saved design' : 'Resume my design') + '</button>' +
      '<button type="button" class="ef-sv-banner__fresh" id="efSvFresh">' + (fromStudio ? 'Use studio choices' : 'Start fresh') + '</button></div>';
    firstStep.parentNode.insertBefore(el, firstStep);
    document.getElementById('efSvResume').addEventListener('click', function () {
      pendingResume = null;
      el.remove();
      applyDesign(snap.s, 'banner', function () {
        if (studioHandoff) { studioHandoff.restored = true; finishStudioHandoff(); }
      });
    });
    document.getElementById('efSvFresh').addEventListener('click', function () {
      pendingResume = null;
      try { localStorage.removeItem(LS_PREFIX + handle()); } catch (e) {}
      lastSaved = '';
      el.remove();
      finishStudioHandoff();
    });
  }

  /* ── UI: modal Save & share ───────────────────────────────────── */
  function klaviyoObj() { return window.klaviyo || window._learnq || null; }

  function openModal() {
    if (restoreBusy) { toast('Restoring your design. Please try again in a moment.'); return; }
    var link = buildLink();
    if (!link) { toast('Pick a few options first — then save'); return; }
    /* An explicit Save of the shopper's current choices may replace a failed
       replay; automatic saves may not. Stop late replay before accepting it. */
    if (heldRestore) { heldRestore = null; restoreSerial++; if (stopLateRestore) stopLateRestore(); }
    pendingResume = null;
    var banner = document.getElementById('efSvBanner');
    if (banner) banner.remove();
    if (studioHandoff) {
      // An explicit Save wins over a studio prefill still waiting to start.
      restoreSerial++;
      studioHandoff.restored = true;
    }
    var modal = document.getElementById('efSvModal');
    modal.hidden = false;
    document.getElementById('efSvLink').value = link;
    var shareBtn = document.getElementById('efSvShare');
    shareBtn.style.display = navigator.share ? '' : 'none';
    var mailRow = document.getElementById('efSvMailRow');
    mailRow.style.display = klaviyoObj() ? '' : 'none';
    autosave();
  }

  function wireSaveOpeners() {
    var openBtn = document.getElementById('efSvOpen');
    if (openBtn) openBtn.addEventListener('click', openModal);
    var reviewLink = document.getElementById('efCfgEmailConfig');
    if (reviewLink) reviewLink.addEventListener('click', function (e) {
      /* Review hides the save chip. Route its visible save link into the same
         dialog before the engine's older mailto-only target listener runs. */
      if (!document.getElementById('efSvModal')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openModal();
    }, true);
  }

  function wireModal() {
    var modal = document.getElementById('efSvModal');
    if (!modal) return;
    document.getElementById('efSvClose').addEventListener('click', function () { modal.hidden = true; });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.hidden = true; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') modal.hidden = true; });

    document.getElementById('efSvCopy').addEventListener('click', function () {
      var inp = document.getElementById('efSvLink');
      var done = function () { toast('Link copied ✓'); dl('ef_cfg_save', { method: 'copy' }); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(inp.value).then(done, function () { inp.select(); document.execCommand('copy'); done(); });
      } else { inp.select(); document.execCommand('copy'); done(); }
    });

    document.getElementById('efSvShare').addEventListener('click', function () {
      var st = state();
      navigator.share({
        title: 'My ' + ((st && st.prodTitle) || 'fireplace door') + ' design — ExceptionalFire',
        url: document.getElementById('efSvLink').value
      }).then(function () { dl('ef_cfg_save', { method: 'share' }); }).catch(function () {});
    });

    document.getElementById('efSvSend').addEventListener('click', function () {
      var email = (document.getElementById('efSvEmail').value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { toast('Enter a valid e-mail'); return; }
      var kl = klaviyoObj();
      if (!kl) { toast('E-mail unavailable — copy the link instead'); return; }
      var st = state();
      var props = {
        'Design URL': document.getElementById('efSvLink').value,
        'Product': (st && st.prodTitle) || handle(),
        'Total': st ? Math.round(st.calcTotal()) / 100 : null
      };
      try {
        if (typeof kl.identify === 'function') {
          /* Klaviyo onsite object (nowe API) */
          kl.identify({ email: email });
          kl.track('EF Saved Design', props);
        } else {
          /* _learnq (starsze API) */
          kl.push(['identify', { $email: email }]);
          kl.push(['track', 'EF Saved Design', props]);
        }
        dl('ef_cfg_save', { method: 'email' });
        toast('Sent — your design is on its way ✓');
        document.getElementById('efSvEmail').value = '';
      } catch (e) { toast('Could not send — copy the link instead'); }
    });
  }

  /* ── Expert CTA: tracking + nudge ─────────────────────────────── */
  function wireExpert() {
    var card = document.getElementById('efExpertCard');
    if (!card) return;
    var video = document.getElementById('efExpertVideo');
    var phone = document.getElementById('efExpertPhone');
    if (video) video.addEventListener('click', function () { dl('ef_cfg_expert_cta', { action: 'video' }); });
    if (phone) phone.addEventListener('click', function () { dl('ef_cfg_expert_cta', { action: 'phone' }); });

    var nudged = false;
    function nudge(why) {
      if (nudged) return;
      nudged = true;
      card.classList.add('ef-exph-nudge');
      dl('ef_cfg_expert_nudge', { reason: why });
    }
    /* 2 nieudane parse'y wymiarów → nudge */
    var badBlur = 0;
    ['efCfgWidth', 'efCfgHeight'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('blur', function () {
        var v = el.value.trim();
        if (!v) return;
        var ok = /^\d+(\.\d+)?$/.test(v) || /^\d+\s*[-\s]\s*\d+\s*\/\s*\d+$/.test(v) || /^\d+\s*\/\s*\d+$/.test(v);
        if (!ok && ++badBlur >= 2) nudge('invalid_dims');
      });
    });
    /* 25 s w widoku karty → nudge */
    if ('IntersectionObserver' in window) {
      var t = null;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { if (!t) t = setTimeout(function () { nudge('dwell'); }, 25000); }
          else if (t) { clearTimeout(t); t = null; }
        });
      }, { threshold: 0.4 });
      io.observe(card);
    }
  }

  /* ── init ─────────────────────────────────────────────────────── */
  /* §R9-H23 (2026-09-03) — ROUND-9-SPEC H23. The edit link, stashed at the
     moment of Add to cart.
     WHY CAPTURE PHASE: the engine's own ATC handler runs on the target phase and
     may navigate or open the drawer; capture guarantees the snapshot is taken
     from a state that still exists.
     WHY NOTHING HAPPENS ON A MANTEL: buildLink() reads window._efCfgState, which
     only ef-configurator-bar-iron.js publishes. On the mantel PDP this file is not even
     loaded, and if it were, buildLink() would return null and nothing would be
     stashed. D9-22 is therefore enforced by the absence of data, not by a
     product check that could drift.
     The pending slot is sessionStorage, not localStorage: it is meaningful for
     exactly one tab and exactly one add-to-cart. */
  function stashEditLink() {
    try {
      var link = buildLink();
      if (!link) return;
      sessionStorage.setItem('ef_edit_pending', JSON.stringify({ link: link, t: Date.now() }));
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var t = (e.target && e.target.closest) ? e.target.closest('#efCfgATC, #efPd2StickyAtc') : null;
    if (t) stashEditLink();
  }, true);

  function init() {
    if (!state()) { setTimeout(init, 400); return; }
    wireModal();
    wireExpert();
    wireSaveOpeners();

    var params = new URLSearchParams(location.search);
    var efd = params.get('efd');
    if (params.has('ef_studio')) {
      var studioData = b64d(efd || '');
      var previous = loadSaved();
      var validStudio = params.get('ef_studio') === '1' && isStudioDesign(studioData);
      if (previous) showResumeBanner(previous, validStudio);
      if (validStudio) {
        studioHandoff = { token: efd, restored: false, warned: false };
        var initialSerial = restoreSerial;
        setTimeout(function () {
          // Resume or explicit Save can resolve the offered draft before this
          // delayed prefill starts; never overwrite that deliberate action.
          if (!studioHandoff || restoreSerial !== initialSerial) return;
          applyDesign(studioData.s, 'studio', function () {
            if (studioHandoff) { studioHandoff.restored = true; finishStudioHandoff(); }
          });
        }, 900);
      } else {
        toast('Studio choices could not be loaded. Choose your options on this product page.');
      }
    } else if (efd) {
      var data = b64d(efd);
      if (data && data.s && data.h === handle()) {
        /* dane + karty potrzebują chwili po _efCfgState */
        setTimeout(function () { applyDesign(data.s, 'url'); }, 900);
      }
    } else {
      var saved = loadSaved();
      if (saved) showResumeBanner(saved);
    }
    setInterval(autosave, 3000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
